import { render, staticRenderFns } from "./FolderAlreadySelectedModal.vue?vue&type=template&id=643edbb2&"
import script from "./FolderAlreadySelectedModal.vue?vue&type=script&lang=ts&"
export * from "./FolderAlreadySelectedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports